module.exports = __webpack_public_path__ + "img/6.84e5b263.svg";